import React, { Fragment } from 'react';
import { isSeniorStaff } from '../../lib/helper/authorisation';
import { niceDateTimeFormatter, userNameFormatter } from '../../lib/helper/formatting';
import * as PropTypes from 'prop-types';

class InvoiceNote extends React.Component {
  render() {
    const { note, deleteNote } = this.props;

    return (
      <div className="invoice-batch-single__note">
        <p className={'invoice-batch-single__note-content'}>
          {isSeniorStaff() && (
            <span
              className="action-icon mr-2"
              onClick={() => {
                deleteNote(note.id);
              }}>
              <span className="sr-only">Delete</span>
              <i className="fas fa-trash" title="Delete note" />
            </span>
          )}
          {niceDateTimeFormatter(note.createdAt)} - <strong>{userNameFormatter(note.createdBy)}</strong> said:
        </p>

        {note.note.split('\n').map((item, key) => {
          return (
            <Fragment key={key}>
              {item}
              <br />
            </Fragment>
          );
        })}
      </div>
    );
  }
}

InvoiceNote.propTypes = {
  note: PropTypes.object.isRequired,
  deleteNote: PropTypes.func,
};

export default InvoiceNote;
